import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <footer className="footer">
        <div className="cta">
          <h3>
            Secured by Legitimately U. Experience the Zero-Trust revolution in identity management.
          </h3>
          <div className="cta-input">
            <input type="email" placeholder="Professional Email" />
            <button>Contact Security Expert</button>
          </div>
        </div>
        <div className="footer-content">
          <div className="footer-links">
            <div>
              <a href="/faq">FAQ</a>
              <a href="/privacy">Privacy</a>
              <a href="/help-centre">Support Portal</a>
            </div>
            <div>
              <a href="/cookie-preferences">Cookie Preferences</a>
              <a href="/legal-notices">Legal Notices</a>
            </div>
            <div>
              <a href="/media-centre">Resources & Guides</a>
              <a href="/terms-of-use">Terms of Use</a>
              <a href="/contact-us">Contact Us</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;